import React from 'react';
import { LIEN_CREDITS, creditsInsuffisants, soldeLabel, useCreditsIA } from './aiWriting';

/** Solde de crédits IA affiché sous un bouton de l'IA, avec un lien si le solde ne suffit pas. */
const SoldeCreditsIA = ({ tache }) => {
  const credits = useCreditsIA();
  const label = soldeLabel(credits, tache);
  if (!label) return null;
  const manque = creditsInsuffisants(credits, tache);
  return (
    <p className={`text-xs mt-1 ${manque ? 'text-red-600' : 'text-gray-500'}`}>
      {label}
      {manque && (
        <>
          {' '}
          <a href={LIEN_CREDITS} target="_blank" rel="noopener noreferrer" className="font-semibold underline">Obtenir plus de crédits</a>
        </>
      )}
    </p>
  );
};

export default SoldeCreditsIA;
